import React, {
  useCallback,
  useState,
  useRef,
  useContext,
  useEffect,
} from "react";
import {
  motion,
  useTransform,
  transform,
  useMotionValue,
  AnimatePresence,
} from "framer-motion";

import WheelSizeContext from "../../../contexts/WheelSizeContext";
import LifeAreasContext from "../../../contexts/LifeAreasContext";

import ProfilePic from "../../profilePic/ProfilePic";

import style from "./Segment.module.css";
import iraPic from "../../../assets/images/ira.jpg";

type SegmentProps = {
  areaKey: string;
  areaRotation: number;
  wheelRotation: number;
  score: number;
  profilePic: string;
  animateToMax: boolean;
};

const Segment = ({
  areaKey,
  areaRotation,
  wheelRotation,
  score,
  profilePic,
  animateToMax,
}: SegmentProps) => {
  // Wheel is made twice as large as 50% is hidden.
  const wheelSize = useContext(WheelSizeContext);

  // const scale = useTransform(score, [0, wheelSize / 2], [1, 0]);
  const scale = score / 10;
  // console.log("Segment score: ", score, "scale: ", scale);

  // // This sets the y value correctly on load from the existing score.
  // const updateYMotionValue = useCallback(() => {
  //   const yVal = transform(
  //     score,
  //     [0, 100],
  //     [dragContainerHeight - dragHandleSize, 0]
  //   );
  //   y.set(yVal);
  // }, [score, dragContainerHeight, y]);

  return (
    <>
      {/* SVG circle is used to clip the image */}
      <svg
        key={areaKey + "-svg"}
        id={areaKey + "-svg"}
        style={{
          position: "absolute",
          width: wheelSize,
          pointerEvents: "none",
        }}
        viewBox={`0 0 ${wheelSize} ${wheelSize}`}
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <clipPath id={`${areaKey}Clip`} clipRule="evenodd">
            <circle
              cx={wheelSize / 2}
              cy={wheelSize / 2}
              r={wheelSize / 2}
              fill="#000000"
              style={{
                transform: `scale(${animateToMax ? 1 : scale})`,
                transformOrigin: "50% 50%",
                transition: "transform 420ms ease",
              }}
            />
          </clipPath>
        </defs>
      </svg>
      <div className={style.container} style={{ height: wheelSize }}>
        <div
          className={style.outerCircle}
          style={{
            width: wheelSize,
            height: wheelSize,
          }}
        >
          <motion.div
            key={areaKey}
            initial={{
              rotate: 0 - (areaRotation + wheelRotation),
              clipPath: `url(#${areaKey}Clip)`,
            }}
            animate={{
              rotate: 0 - (areaRotation + wheelRotation),
            }}
            transition={{ duration: 0.8, ease: "linear" }}
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              // transform: `rotate(${0 - (areaRotation + wheelRotation)}deg)`,
              clipPath: `url(#${areaKey}Clip)`,
            }}
          >
            <ProfilePic size={wheelSize} src={profilePic} />
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default Segment;
